import Period from "./horiziontalPeriodCalculator"
import { ReportField, ReportFillingType, ReportType } from "../constnats/reportConstants"
import ReportUtils from "./reportUtils"
import CollectionUtils from './collections'
import { PERIOD_TO_QUARTER_MAP, QUARTER_TO_PERIODS_MAP } from "../constnats/periods"

const DUPLICATED_REPORTS_MSG = "The table contains at least two reports with same year, period, version and format."

//TODO Remove/Rename
class ReportsUtils {

    /**
     * @param {[]} dynamicFlatDescriptors Required 
     */
    constructor(dynamicFlatDescriptors) {
        this._dynamicFlatDescriptors = dynamicFlatDescriptors
    }

    static compare(a, b, desc = false) {
        let periodCompDiff;

        //TODO Refactore by removing the nested IFs
        if (a[ReportField.YEAR] === b[ReportField.YEAR]) {
            periodCompDiff = Period.compare(a[ReportField.PERIOD], b[ReportField.PERIOD]);
            if (periodCompDiff === 0) {
                periodCompDiff = ReportsUtils._compareByFilingType(a[ReportField.TYPE], b[ReportField.TYPE]);
                if (periodCompDiff === 0) {
                    periodCompDiff = ReportsUtils._compareByReportType(a[ReportField.REPORT_TYPE], b[ReportField.REPORT_TYPE]);
                }
            }
        } else {
            periodCompDiff = a[ReportField.YEAR] - b[ReportField.YEAR];
        }

        return desc === true ? periodCompDiff * -1 : periodCompDiff
    }

    static sort(reports, desc = false) {
        reports.sort((a, b) => ReportsUtils.compare(a, b, desc));

        return reports
    }

    /**
    * @param {[]} knownReports Known reports as stored in the database. Required 
    * @param {func} reportDuplicatesHandler Required
    * @param {boolean} enableAsserts Optional 
    * @returns {[]} not-null array that does not contain more than one report for same period and year. 
    */
    getCalculatedReports(knownReports, reportDuplicatesHandler, enableAsserts) {
        return Period.getCalculatedReports(knownReports,
            this._dynamicFlatDescriptors, reportDuplicatesHandler, enableAsserts)
    }

    static _compareByFilingType(filingTypeA, filingTypeB) {
        return ReportsUtils._compare(filingTypeA, filingTypeB, ReportFillingType.PERSISTENT_TYPES)
    }

    static _compareByReportType(reportTypeA, reportTypeB) {
        return ReportsUtils._compare(reportTypeA, reportTypeB, ReportType.ALL)
    }

    static _compare(a, b, collection) {
        for (const type of collection) {
            if (a === type && b === type) {
                return 0
            } else if (a === type) {
                return -1
            } else if (b === type) {
                return 1
            }
        }
    }

    static getRelatedQuarterlyReports(report, reports) {
        const filing = ReportsUtils.getFiling(report);
        const periodsForQuarter = ReportsUtils._getPeriodsForQuarter(filing.year, filing.quarter);
        return reports.filter((r) =>
            r[ReportField.ID] !== report[ReportField.ID] &&
            r[ReportField.REPORT_TYPE] === report[ReportField.REPORT_TYPE] &&
            periodsForQuarter.some(
                (p) =>
                    p.year === r[ReportField.YEAR] &&
                    p.period === r[ReportField.PERIOD] &&
                    p.version === r[ReportField.TYPE]
            ),
        )
    }

    static getFiling(report) {
        const year =
            report[ReportField.TYPE] === ReportFillingType.ORIGINAL_FILLING
                ? report[ReportField.YEAR]
                : report[ReportField.YEAR] + 1;
        const quarter = PERIOD_TO_QUARTER_MAP[report[ReportField.PERIOD]];
        return { year, quarter };
    }

    static _getPeriodsForQuarter(year, quarter) {
        const periods = QUARTER_TO_PERIODS_MAP[quarter];
        if (!periods) {
            throw new Error('quarter must be 1, 2, 3, or 4');
        }
        return periods.flatMap((period) => [
            { year, period, version: ReportFillingType.ORIGINAL_FILLING },
            { year: year - 1, period, version: ReportFillingType.LATEST_FILLING },
        ]);
    }

}

export { ReportsUtils, DUPLICATED_REPORTS_MSG }
